export class ElementToggleContent {
	root;

	selectors = {
		node: '.js-element-toggle',
		toggle: '.js-element-toggle__toggle',
		element: '.js-element-toggle__element',
	};

	constructor() {}

	/**
	 * @param {string} rootSelector
	 */
	init(rootSelector) {
		const self = this;

		self.root = document.querySelector(rootSelector || 'body'); // fallback to whole document

		const elements = [...self.root.querySelectorAll(self.selectors.node)];
		elements.forEach((element) => self._bindToggle(element));
	}

	/**
	 * @param {HTMLElement} node
	 * @private
	 */
	_bindToggle(node) {
		const self = this;

		// get elements
		let toggle = node.querySelector(self.selectors.toggle);
		const element = node.querySelector(self.selectors.element);

		if (!toggle || !element) {
			return;
		}

		// get data
		const toggleOriginalContent = this._getElementContent(toggle, 'original');
		const toggleToggledContent = this._getElementContent(toggle, 'toggled');
		const elementOriginalContent = this._getElementContent(element, 'original');
		const elementToggledContent = this._getElementContent(element, 'toggled');

		// unbind click
		const newToggle = toggle.cloneNode();
		toggle.parentNode.replaceChild(newToggle, toggle);
		toggle = newToggle;

		// initialize content
		toggle.innterHTML = '';
		toggle.appendChild(toggleOriginalContent);
		toggle.appendChild(toggleToggledContent);

		element.innerHTML = '';
		element.appendChild(elementOriginalContent);
		element.appendChild(elementToggledContent);

		const showOriginal = () => {
			toggleOriginalContent.style.display = 'inline';
			toggleToggledContent.style.display = 'none';
			elementOriginalContent.style.display = 'inline';
			elementToggledContent.style.display = 'none';
			toggle.dataset.isToggled = 'false';
		};

		const showToggled = () => {
			toggleOriginalContent.style.display = 'none';
			toggleToggledContent.style.display = 'inline';
			elementOriginalContent.style.display = 'none';
			elementToggledContent.style.display = 'inline';
			toggle.dataset.isToggled = 'true';
		};

		showOriginal();

		// bind click
		toggle.addEventListener('click', (e) => {
			e.preventDefault();

			const isToggled = toggle.dataset.isToggled === 'true';

			if (isToggled) {
				showOriginal();
			} else {
				showToggled();
			}
		});
	}

	/**
	 * Get the content of the element
	 * @param {HTMLElement} element
	 * @param {'original' | 'toggled'} attribute
	 * @returns {HTMLElement}
	 * @private
	 */
	_getElementContent(element, attribute) {
		const content = element.dataset[attribute];

		/**
		 * @type {HTMLElement}
		 */
		let contentEl;

		if (content.startsWith('#')) {
			contentEl = document.querySelector(content);
		} else {
			contentEl = document.createElement('span');
			contentEl.innerHTML = content;
		}

		contentEl.style.display = 'none';

		return contentEl;
	}
}

window.ElementToggleContent = new ElementToggleContent();
window.ElementToggleContent.init();
